// Хранилище состояния блокировки для всех чеклистов
// Прикрепляем к window, чтобы состояние переживало горячую перезагрузку (HMR) в режиме разработки
if (!window.checklistsBlockingState) {
    window.checklistsBlockingState = new Map();
}
let checklistsBlockingState = window.checklistsBlockingState;
let blockingTimeout = null;

/**
 * Регистрирует чеклист в системе блокировки этапов
 * @param {number} checklistId - ID чеклиста
 * @param {number} percent - процент заполнения
 * @param {boolean} required - обязательность заполнения
 * @param {boolean} visible - видимость чеклиста
 * @param {string} name - название чеклиста (для отладки)
 */
export function registerChecklistBlocking(checklistId, percent, required, visible, name = '') {
    const action = !required ? 'удалить' : 'зарегистрировать';
    if (!required) {
        // Удаляем из блокировки только если чеклист не обязательный
        checklistsBlockingState.delete(checklistId);
    } else {
        // Регистрируем или обновляем состояние для обязательных чеклистов
        // даже если они временно не видимы (свернуты)
        checklistsBlockingState.set(checklistId, {
            percent,
            required,
            visible,
            name,
            lastUpdate: Date.now()
        });
    }
    
    // Дебаунсинг для обновления блокировки
    if (blockingTimeout) {
        clearTimeout(blockingTimeout);
    }
    
    blockingTimeout = setTimeout(() => {
        updatePipelineBlocking();
    }, 150);
}

/**
 * Обновляет состояние блокировки этапа на основе всех зарегистрированных чеклистов
 */
function updatePipelineBlocking() {
    const now = Date.now();
    const staleTimeout = 5000; // 5 секунд для удаления устаревших записей
    
    // Очищаем устаревшие записи
    for (const [id, state] of checklistsBlockingState.entries()) {
        if (now - state.lastUpdate > staleTimeout) {
            checklistsBlockingState.delete(id);
        }
    }
    
    // Получаем все обязательные чеклисты (включая свернутые)
    const allRequiredChecklists = Array.from(checklistsBlockingState.values())
        .filter(state => state.required);
    
    if (allRequiredChecklists.length === 0) {
        // Нет обязательных чеклистов - разблокируем
        disablePipelineIfNeeded(100, false);
        return;
    }
    
    // Для блокировки учитываем только видимые обязательные чеклисты
    const visibleRequiredChecklists = allRequiredChecklists.filter(state => state.visible);
    
    // Если нет видимых обязательных чеклистов, но есть обязательные (свернутые)
    if (visibleRequiredChecklists.length === 0) {
        // Считаем что свернутые чеклисты не должны блокировать
        disablePipelineIfNeeded(100, false);
        return;
    }
    
    // Проверяем заполненность видимых обязательных чеклистов
    const incompleteChecklists = visibleRequiredChecklists.filter(state => state.percent < 100);
    const shouldBlock = incompleteChecklists.length > 0;
    
    // Применяем блокировку/разблокировку
    const averagePercent = visibleRequiredChecklists.reduce((sum, state) => sum + state.percent, 0) / visibleRequiredChecklists.length;
    disablePipelineIfNeeded(averagePercent, shouldBlock);
}

/**
 * Блокирует или разблокирует контейнер этапа сделки
 * @param {number} percent - процент заполнения чек-листа
 * @param {boolean} required - флаг обязательности заполнения
 * @param {string} selector - CSS-селектор контейнера (по умолчанию pipeline-select-view.card-cf-lead-status-select)
 */
export function disablePipelineIfNeeded(percent, required, selector = ".pipeline-select-view.card-cf-lead-status-select") {
    const pipelineContainer = document.querySelector(selector);
    if (!pipelineContainer) return;

    if (required) {
        pipelineContainer.style.pointerEvents = "none";
        pipelineContainer.style.opacity = "0.5";
        pipelineContainer.title = "Заполните все обязательные чеклисты для перехода на следующий этап";
    } else {
        pipelineContainer.style.pointerEvents = "";
        pipelineContainer.style.opacity = "";
        pipelineContainer.title = "";
    }
}

/**
 * Очищает состояние блокировки (используется при переходе между сделками)
 */
export function clearChecklistBlocking() {
    // Очищаем и глобальное, и локальное состояние
    if (window.checklistsBlockingState) {
        window.checklistsBlockingState.clear();
    }
    checklistsBlockingState.clear();

    if (blockingTimeout) {
        clearTimeout(blockingTimeout);
        blockingTimeout = null;
    }
} 